export default __webpack_public_path__ + "static/media/cancel_circle_red.2bdf06a5.svg";